import React from "react";
import { useTranslation } from "react-i18next";

const STATUS_BG_BY_ENUM = {
  CREATED: "#0283F4",
  NOT_STARTED: "#A7ADC3",
  IN_PROGRESS: "#FEA26F",
  FINISHED: "#0AD69F",

  ASSIGNED_FOR_COUNTING: "#E6F0FF",
  COUNTING_IN_PROGRESS: "#E6F0FF",
  COUNTING_FINISHED: "#E6F0FF",

  ASSIGNED_FOR_CONTROL: "#FFEBD9",
  CONTROL_IN_PROGRESS: "#FFEBD9",
  CONTROL_FINISHED: "#E7FBF1",

  VALIDATED: "#E7FBF1",

  ASSIGNED_FOR_ECART: "#FFF5CC",
  ECART_IN_PROGRESS: "#FEA26F",
  ECART_FINISHED: "#06D6A0",
  CANCELLED: "#38485C",
  SUBMITED: "#FFD166",
  IN_DISPUTE: "#FF6B6B",
};

const StatusPill = ({ statusEnum }) => {
  const { t } = useTranslation();
  if (!statusEnum) return null;

  const key = String(statusEnum).toUpperCase();
  const bg = STATUS_BG_BY_ENUM[key] || "#ECECEC";
  const label = t(`inventory_status.${key}`, { defaultValue: key });

  return (
    <span
      className=" items-center inline-block w-fit text-center px-2 py-[4px] rounded-[12px] text-[9px] font-bold"
      style={{ backgroundColor: bg, color: "#FFFFFF" }}
    >
      {label.toUpperCase()}
    </span>
  );
};

const Card = ({ label = "", title = "", subline = "", status = "", optionsMenu = null, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="rounded-2xl bg-white p-5 relative h-full cursor-default"
      style={{ boxShadow: "0px 6px 26px #626B7D12" }}
    >
      <div className="flex items-center gap-2">
        <StatusPill statusEnum={status} />
        <div className="text-[#0283F4] uppercase font-bold text-[12px]">
          {label}
        </div>
      </div>

      <div className="mt-1 text-[#38485C] font-semibold text-[16px] leading-tight">
        {title}
      </div>

      {!!subline && (
        <div className="mt-1 text-[#6B6BF8] font-extrabold text-[16px]">
          {subline}
        </div>
      )}

      {optionsMenu && <div className="absolute bottom-3 right-3">{optionsMenu}</div>}
    </div>
  );
};

export default Card;
